export interface UmpireFeaturePermissions {
  full_access: boolean;

  index: boolean;

  create: boolean;

  update: boolean;

  destroy: boolean;

  details: boolean;
}
